import styled from "styled-components";

export const CalendarBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  .fui-CalendarPicker__buttonRow {
    display: flex;
    justify-content: space-between;
  }
  .fui-Calendar__goTodayButton {
    margin-right: 0px;
    width: 100%;
  }
  .fui-CalendarDayGrid__daySingleSelected {
    display: flex;
    justify-content: center;
  }
  .fui-CalendarDayGrid__dayIsToday {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .fui-CalendarPicker,
  .fui-CalendarDay {
    width: 100%;
    padding: 8px 0px;
  }
  .fui-Calendar,
  .fui-Calendar__monthPickerWrapper,
  .fui-CalendarDayGrid__table {
    width: 100%;
  }
`;
